import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — L-junction wall piece: two half-length wall stubs (0.5 m each,
// including the shared corner) meeting at the tile centre, one arm along +X
// and one along +Z. Same plaster + baseboard styling as wall-plain, so a
// straight wall tile chains cleanly into either arm.
const PLASTER = "#e8e4dc";
const BASEBOARD = "#c9c2b6";

export const wallCorner = defineModel({
  id: "wall-corner",
  batchId: "modern",
  name: "Wall corner",
  tags: ["modern", "interior", "structure", "wall", "corner", "junction"],
  summary: "An L-junction wall corner with arms along +X and +Z.",
  description:
    "The corner piece of the Modern Living wall system: two half-length " +
    "(0.5 m) plastered stubs, 0.12 m thick and 2.6 m high, meeting at the " +
    "tile centre with arms toward +X and +Z. Rotate in 90-degree steps to " +
    "orient; straight wall tiles continue either arm.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // arm along +X (from the tile centre to the +X tile edge)
      { geometry: new THREE.BoxGeometry(0.5, 2.6, 0.12), color: PLASTER, position: [0.25, 1.3, 0] },
      // arm along +Z
      { geometry: new THREE.BoxGeometry(0.12, 2.6, 0.5), color: PLASTER, position: [0, 1.3, 0.25] },
      // baseboards
      { geometry: new THREE.BoxGeometry(0.5, 0.1, 0.15), color: BASEBOARD, position: [0.25, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.15, 0.1, 0.5), color: BASEBOARD, position: [0, 0.05, 0.25] },
    ];
  },
  animations: [],
});
